import { CommonModule, DatePipe, NgClass } from '@angular/common';
import { Component, ViewChild, Input, OnInit, OnDestroy, ChangeDetectorRef, signal, computed, input, output, ElementRef, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { CarouselModule } from 'primeng/carousel';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { SkeletonModule } from 'primeng/skeleton';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';
import { IUser, ISessionProfile, ISwitchProfileRequest } from 'src/app/interface/user.interface';
import { AuthService } from 'src/app/shared/services/auth.service';
import { UserEmailMobileVerificationEnum, UserTypeIdEnum } from 'src/app/shared/interfaces/user.interface';
import { _PAuserClient } from 'src/app/clients/user.client';
import { ToastrService } from 'src/app/shared/services/toastr.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { PaHttpClient } from 'src/app/clients/http-client';
import { filter, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject, forkJoin } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { authToken, mainUserToken, mainUserRefreshToken, mainUserSessionId, mainUserId, authRefreshToken } from 'src/app/util/constant/variables';

import { InitialsPipe } from 'src/app/shared/pipe/initials.pipe';
import { ContactService } from '../../../views/contacts/services/contact.service';
import { CollabListComponent } from 'src/app/shared/views/collab-list/collab-list.component';
import { ActivityPointsService } from 'src/app/views/activity-points-stats/services/activity-points.service';
import { CollabService } from 'src/app/views/collabs/services/collab.service';
import { GetVerifiedPopupComponent, VERIFICATION_SNOOZE_KEY } from 'src/app/shared/components/get-verified-popup/get-verified-popup.component';
import { ReferralService, VerifiedUser } from '../../../auth/signup-v2/services/referral.service';
import { ImpersonationService } from 'src/app/shared/services/impersonation.service';
import { InvitePopupComponent } from 'src/app/shared/components/invite-popup/invite-popup.component';

@Component({
  selector: 'pa-profile',
  standalone: true,
  imports: [CommonModule, CarouselModule, ButtonModule, MenuModule, SkeletonModule, RouterModule, InitialsPipe, CollabListComponent, InvitePopupComponent],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  providers: [DatePipe, _PAuserClient, PaHttpClient]
})

export class HomeProfileComponent implements OnInit, OnDestroy,AfterViewInit {
  @Input() showBorder: boolean = true;
  @Input() showSwitchAccount: boolean = false;
  @Input() showProfileInfo: boolean = true;
  @Input() isMyCollab : boolean = false;
  readonly collabRailOffsetOut = output<number>();
  @ViewChild('profileMenu') profileMenu!: Menu;
  @ViewChild('collabUpperSection') collabUpperSection!: ElementRef<HTMLDivElement>;
  @ViewChild('switchUpperSection') switchUpperSection!: ElementRef<HTMLDivElement>;
  @ViewChild('collabListScroll') collabListScroll!: ElementRef<HTMLDivElement>;
  @ViewChild('switchListScroll') switchListScroll!: ElementRef<HTMLDivElement>;


  @ViewChild(CollabListComponent) collabListComponent?: CollabListComponent;
  currentUser: IUser | null = null;
  isDesktop: boolean = false;
  menuItems: MenuItem[] = [];
  accountMenuItems: MenuItem[] = [];
  activeProfileForMenu: ISessionProfile | null = null;
  @ViewChild('accountMenu') accountMenu!: Menu;
  UserEmailMobileVerificationEnum = UserEmailMobileVerificationEnum;
  verificationValue!: string;
  sessionProfiles: ISessionProfile[] = [];
  isLoadingProfiles: boolean = false;
  isContactRoute: boolean = false;
  readonly collabRailOffset = signal(0);
private collabRailTarget = 0;
private collabRailMax = 0;
private collabRailAnimId: number | null = null;
private collabRailCleanup: (() => void) | null = null;
private lastListScrollTop = 0;
private isUpperHidden = false;

private collabUpperHeight = 0;
private collabListTouchCleanup: (() => void) | null = null;
private switchListTouchCleanup: (() => void) | null = null;
private switchListLastScrollTop = 0;
  readonly switchRailOffset = signal(0);
  private switchRailTarget = 0;
  private switchRailMax = 0;
  private switchRailAnimId: number | null = null;
  private switchRailCleanup: (() => void) | null = null;
  private switchUpperHeight = 0;
  isFundraiseRoute:boolean = false;
  isPrimeRoute:boolean = false;
  profileData: any = null;
  isLoadingProfile = signal(false);
  location: string = '';
  userName:string ='';

  contactsCount: string = '';
  followersCount: string = '';

  // Contact metrics for Contacts page profile section
  isLoadingContactMetrics = signal(false);

  totalContactsMetric = signal('');
  personalContactsMetric = signal('');
  businessContactsMetric = signal('');
  contractorsContactsMetric = signal('');
  managementContactsMetric = signal('');
  serviceProviderContactsMetric = signal('');


  readonly lifetimeActivityPoints = signal<string>('—');
  readonly activityPointsLevel = signal<string>('');
  readonly activityPointsWithTierDisplay = computed(() => {
    const level = this.activityPointsLevel();
    return level ? `${this.lifetimeActivityPoints().replace(/ pts$/, '')} | ${level}` : this.lifetimeActivityPoints();
  });
  readonly referralToken = signal<string>('');
  readonly showInvitePopup = signal(false);
  readonly isLoadingMyCollabs = signal(false);
  readonly myCollabs = signal<{ collab_id: string; title: string; display_image: string; relative_time: string }[]>([]);
  readonly fallbackImage = 'assets/images/dummy-avatar.jpg';
  readonly userId = computed(() => this.auth.getUser()?.user_id ?? '');
  readonly profileRoute = computed(() => ['/prime-user', this.userId()]);
  readonly meetupRoute = computed(() => ['/meetup-user', this.userId()]);

  // Mobile/tablet panel mode
  readonly showTabs = input<boolean>(false);
  readonly mobileActiveTab = signal<'collabs' | 'switch'>('collabs');
  readonly closePanel = output<void>();
  readonly showDotsMenu = signal(false);
  readonly showAccountMenuIndex = signal<number | null>(null);
  private destroy$ = new Subject<void>();
  private resizeHandler = () => this.checkScreenSize();
  readonly collabPage = signal(1);
readonly collabHasMore = signal(false);
readonly isLoadingMoreCollabs = signal(false);
private readonly COLLAB_PAGE_LIMIT = 10;
private readonly COLLAB_ITEM_HEIGHT = 82; 
private listLastScrollTop = 0;
private listTouchStartY = 0;
private listTouchTracking = false;

  // ── "View Account" global user search (super admin only) ──────────
  // Backed by GET /user/list/verified (via ReferralService), same source
  // used by the home page's "View user account as" search.
  readonly viewAccountQuery = signal('');
  readonly viewAccountTab = signal<'all' | 'resident' | 'management' | 'service-provider' | 'contractor'>('all');
  readonly viewAccountLoading = signal(false);
  readonly viewAccountResults = signal<VerifiedUser[]>([]);
  readonly viewedRecentlyAccounts = signal<VerifiedUser[]>([]);
  readonly viewedRecentlyLoading = signal(false);
  readonly activeViewAccountRowMenu = signal<string | null>(null);
  readonly viewAccountDisplayList = computed(() =>
    this.viewAccountQuery().trim() ? this.viewAccountResults() : this.viewedRecentlyAccounts()
  );
  private readonly viewAccountSearchSubject = new Subject<string>();
  private viewedRecentlyRequestToken = 0;
  private viewAccountRequestToken = 0;

  get isSuperAdmin(): boolean {
    return String(this.currentUser?.user_type) === UserTypeIdEnum.ADMIN;
  }

  isProfilePictureBlocked(): boolean {
    const status = this.currentUser?.profile_picture_moderation_status;
    return status === 'flagged' || status === 'blocked';
  }

  isPictureBlocked(status: string | null | undefined): boolean {
    return status === 'flagged' || status === 'blocked';
  }

  constructor(
    private auth: AuthService,
    private userClient: _PAuserClient,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private httpClient: PaHttpClient,
    private contactService: ContactService,
    private activityPointsService: ActivityPointsService,
    private referralService: ReferralService,
    private impersonationService: ImpersonationService,
  ) {
    this.viewAccountSearchSubject.pipe(
      takeUntilDestroyed(),
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(query => {
      const trimmed = query.trim();
      if (!trimmed) {
        this.resetViewAccountSearchState();
        return;
      }
      this.fetchViewAccountResults(trimmed);
    });
  }

  onViewAccountInput(value: string): void {
    this.viewAccountQuery.set(value);
    if (!value.trim()) {
      this.resetViewAccountSearchState();
      // Recently-viewed may be stale for the current tab if it was switched
      // while a search query was active (fetchRecentlyViewedAccounts is only
      // called from setViewAccountTab when the query is already empty).
      this.fetchRecentlyViewedAccounts();
    }
    this.viewAccountSearchSubject.next(value);
  }

  setViewAccountTab(tab: 'all' | 'resident' | 'management' | 'service-provider' | 'contractor'): void {
    if (this.viewAccountTab() === tab) return;
    this.viewAccountTab.set(tab);
    const query = this.viewAccountQuery().trim();
    if (query) {
      this.fetchViewAccountResults(query);
    } else {
      this.fetchRecentlyViewedAccounts();
    }
  }

  // 1=Admin, 2=Tenant/Resident, 3=Management, 4=Service Provider, 5=Contractor
  // — 'all' omits the param so the API returns every type.
  private readonly VIEW_ACCOUNT_TAB_USER_TYPE: Record<string, string> = {
    resident: '2',
    management: '3',
    'service-provider': '4',
    contractor: '5',
  };

  // Bumps the request token so any in-flight fetch from a since-cleared/replaced
  // query can no longer overwrite results.
  private resetViewAccountSearchState(): void {
    this.viewAccountRequestToken++;
    this.viewAccountResults.set([]);
    this.viewAccountLoading.set(false);
  }

  // Persisted server-side (unlike the old in-memory-only prepend in
  // onViewAccountRowClick, which was wiped by the full page reload that
  // switching accounts triggers) — GET /super-admin/recent-viewed-users.
  private fetchRecentlyViewedAccounts(): void {
    this.viewedRecentlyLoading.set(true);
    const token = ++this.viewedRecentlyRequestToken;
    const params: Record<string, number | string> = { page: 1, limit: 10 };
    const userType = this.VIEW_ACCOUNT_TAB_USER_TYPE[this.viewAccountTab()];
    if (userType) params['user_type'] = userType;

    this.httpClient.getWithParams('super-admin/recent-viewed-users', params).subscribe({
      next: (res: any) => {
        if (token !== this.viewedRecentlyRequestToken) return;
        this.viewedRecentlyLoading.set(false);
        if (!res?.success || !Array.isArray(res.data)) return;
        const mapped: VerifiedUser[] = res.data
          .map((x: any) => {
            const details = x?.viewed_user_details;
            if (!details || typeof details !== 'object') return null;
            const userId = details.user_id ?? x.viewed_user_id;
            if (!userId) return null;
            // Profile picture lives in the documents array, not a top-level field.
            const docs: any[] = Array.isArray(details.documents) ? details.documents : [];
            const profilePicture = docs.find((d: any) => d?.doc_type?.doc_type === 'profile_pic' || d?.doc_name === 'Profile Picture')?.url || '';
            return { ...details, user_id: userId, profile_picture: profilePicture } as VerifiedUser;
          })
          .filter((u: VerifiedUser | null): u is VerifiedUser => !!u);
        this.viewedRecentlyAccounts.set(mapped);
      },
      error: () => {
        if (token !== this.viewedRecentlyRequestToken) return;
        this.viewedRecentlyLoading.set(false);
      },
    });
  }

  private fetchViewAccountResults(query: string): void {
    const token = ++this.viewAccountRequestToken;
    this.viewAccountLoading.set(true);
    const tab = this.viewAccountTab();

    // Management/Service Provider/Contractor are all "business" accounts on this
    // endpoint — it only splits personal vs business server-side, so a specific tab
    // passes user_type too (narrows server-side if supported) and always re-filters
    // client-side as a fallback. Also pulls a much larger page so the client-side
    // filter isn't starved by page-1-only results if the backend ignores user_type.
    const businessUserType = tab === 'management' ? UserTypeIdEnum.MANAGEMENT
      : tab === 'service-provider' ? UserTypeIdEnum.SERVICE_PROVIDER
      : tab === 'contractor' ? UserTypeIdEnum.CONTRACTOR
      : undefined;
    const businessLimit = businessUserType ? 100 : 10;

    const requests = [];
    if (tab === 'all' || tab === 'resident') {
      requests.push(this.referralService.getVerifiedUsers({ page: 1, limit: 10, type: 'personal', search: query }));
    }
    if (tab === 'all' || businessUserType) {
      requests.push(this.referralService.getVerifiedUsers({ page: 1, limit: businessLimit, type: 'business', search: query, user_type: businessUserType }));
    }

    forkJoin(requests).subscribe({
      next: (responses) => {
        if (token !== this.viewAccountRequestToken) return;
        let results = responses.flatMap(res => res.success ? res.data : []);
        if (tab === 'management') {
          results = results.filter(u => String(u.user_type) === UserTypeIdEnum.MANAGEMENT);
        } else if (tab === 'service-provider') {
          results = results.filter(u => String(u.user_type) === UserTypeIdEnum.SERVICE_PROVIDER);
        } else if (tab === 'contractor') {
          results = results.filter(u => String(u.user_type) === UserTypeIdEnum.CONTRACTOR);
        }
        this.viewAccountResults.set(results);
        this.viewAccountLoading.set(false);
      },
      error: () => {
        if (token !== this.viewAccountRequestToken) return;
        this.viewAccountResults.set([]);
        this.viewAccountLoading.set(false);
      },
    });
  }

  getViewAccountName(user: VerifiedUser): string {
    if (!user) return 'N/A';
        const userType = String(user.user_type);
        const name = userType === '3' ? (user.management_name || '') :
                     userType === '4' ? (user.service_provider_name || '') :
                     `${user.first_name || ''} ${user.last_name || ''}`.trim();
        return name || 'N/A';
  }

  getViewAccountRoleLabel(user: VerifiedUser): string {
    switch (String(user.user_type)) {
      case '2': return 'RESIDENT';
      case '3': return 'MANAGEMENT';
      case '4': return 'SERVICE PROVIDER';
      case '5': return 'CONTRACTOR';
      default: return '';
    }
  }

  onViewAccountRowClick(user: VerifiedUser): void {
    if (String(user.user_id) === String(this.currentUser?.user_id)) {
      this.router.navigate(['/contacts', user.user_id]);
      this.closePanel.emit();
      return;
    }

    this.closePanel.emit();

    this.spinner.showSpinner();
    this.impersonationService.startImpersonation(user.user_id, this.currentUser?.fcm_token).then(response => {
      this.spinner.hideSpinner();
      if (response?.status && response?.token) {
        if (response.data) {
          this.auth.updateData(response.data);
        }
        this.viewedRecentlyAccounts.update(list => {
          const withoutUser = list.filter(u => u.user_id !== user.user_id);
          return [user, ...withoutUser].slice(0, 10);
        });
        this.toastr.showSuccess(`Switched to ${this.getViewAccountName(user)}`);
        setTimeout(() => { window.location.href = '/home'; }, 800);
      } else {
        this.toastr.showError(response?.message || 'Failed to switch account');
      }
    }).catch((error: any) => {
      this.spinner.hideSpinner();
      this.toastr.showError(error?.error?.message || 'Failed to switch account');
    });
  }

  // Rendered `fixed` (positioned from the trigger button's own rect) instead of
  // `absolute` inside the scrollable list — an absolute popup gets clipped by the
  // list's overflow-y-auto whenever the row is near the top or bottom of the panel.
  readonly viewAccountRowMenuPosition = signal<{ top: number; left: number } | null>(null);
  private readonly ROW_MENU_WIDTH = 160;
  private readonly ROW_MENU_EST_HEIGHT = 220;

  toggleViewAccountRowMenu(user: VerifiedUser, event: MouseEvent): void {
    if (this.activeViewAccountRowMenu() === user.user_id) {
      this.activeViewAccountRowMenu.set(null);
      this.viewAccountRowMenuPosition.set(null);
      return;
    }
    const rect = (event.currentTarget as HTMLElement).getBoundingClientRect();
    const openUpward = rect.bottom + this.ROW_MENU_EST_HEIGHT > window.innerHeight;
    this.viewAccountRowMenuPosition.set({
      top: openUpward ? rect.top - this.ROW_MENU_EST_HEIGHT : rect.bottom + 4,
      left: rect.right - this.ROW_MENU_WIDTH,
    });
    this.activeViewAccountRowMenu.set(user.user_id);
  }

  // Moderation actions below are UI-only placeholders — no backend endpoint
  // exists yet for banning/blocking/activating/verifying an account here.
  onBanAccount(user: VerifiedUser): void {
    this.activeViewAccountRowMenu.set(null);
    this.toastr.showInfo(`Ban account: coming soon for ${this.getViewAccountName(user)}`);
  }

  onBlockAccountAccess(user: VerifiedUser): void {
    this.activeViewAccountRowMenu.set(null);
    this.toastr.showInfo(`Block access: coming soon for ${this.getViewAccountName(user)}`);
  }

  onActivateAccount(user: VerifiedUser): void {
    this.activeViewAccountRowMenu.set(null);
    this.toastr.showInfo(`Activate account: coming soon for ${this.getViewAccountName(user)}`);
  }

  onVerifyAccount(user: VerifiedUser): void {
    this.activeViewAccountRowMenu.set(null);
    this.toastr.showInfo(`Verify account: coming soon for ${this.getViewAccountName(user)}`);
  }

  onEditAccount(user: VerifiedUser): void {
    this.activeViewAccountRowMenu.set(null);
    this.router.navigate(['/contacts', user.user_id]);
    this.closePanel.emit();
  }

  ngOnInit(): void {
    this.accountMenuItems = [
      {
        label: 'Get verified',
        icon: 'pi pi-verified',
        command: () => this.onGetVerified()
      },
      {
        label: 'View Profile Center',
        icon: 'pi pi-user',
        command: () => this.onViewProfileCenter()
      },
      {
        label: 'Remove from list',
        icon: 'pi pi-trash',
        command: () => this.onRemoveAccount()
      }
    ];
    this.currentUser = this.auth.getUser();
    this.checkScreenSize();
    this.checkRoute();
    if (this.isSuperAdmin) {
      this.fetchRecentlyViewedAccounts();
    }
    if ((this.isMyCollab || this.showTabs()) && !this.myCollabs().length) {
      this.fetchMyCollabs();
    }
    // Check if we have main user token and use it when fetching session profiles
    // Always use main user token if available (should always be available after login)
    const mainToken = localStorage.getItem(mainUserToken);
    if (mainToken) {
      console.log('ngOnInit: Fetching session profiles with MAIN USER token');
      this.fetchSessionProfiles(mainToken);
    } else {
      console.warn('ngOnInit: Main user token not found, fetching without token');
      this.fetchSessionProfiles();
    }
    this.updateMenuItems();
    this.fetchActivityPoints();
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('orientationchange', this.resizeHandler);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      this.checkRoute();
    });

    this.auth.getUserData().subscribe((userData: any) => {
      if (userData && Object.keys(userData).length > 0) {
        this.currentUser = userData;
        this.updateMenuItems();
        this.cdr.detectChanges();
      }
    });
  }

 private getStickyHeaderHeight(): number {
  const el = document.querySelector('.flex-shrink-0.bg-white.z-\\[99\\]') as HTMLElement;
  const measured = el?.offsetHeight;
  return measured && measured > 100 ? measured : 240;
}
readonly mobilePanelHeight = computed(() => {
  const count = this.myCollabs().length;
  const stickyH = this.getStickyHeaderHeight();
  const upperH = this.collabUpperSection?.nativeElement?.offsetHeight || 160;
  const MAX_HEIGHT = 650;

  if (this.mobileActiveTab() === 'switch') {
    const base = Math.min(MAX_HEIGHT, window.innerHeight - 136);
    return `${Math.max(260, base)}px`;
  }

  if (count < 4) {
    const displayCount = this.isLoadingMyCollabs() ? 3 : count;
    const contentH = stickyH + upperH + (displayCount * this.COLLAB_ITEM_HEIGHT) + 30;
    return `${Math.min(MAX_HEIGHT, Math.max(contentH, stickyH + 150))}px`;
  }

  return `${MAX_HEIGHT}px`;
});


getCollabContainerHeight(): string {
  const stickyHeaderH = 310;
  const available = window.innerHeight - stickyHeaderH;
  const offset = Math.round(this.collabRailOffset());
  return `${Math.max(150, available - offset)}px`;
}
readonly collabListMaxHeight = computed(() => {
  const stickyH = this.getStickyHeaderHeight();
  const upperH = this.collabUpperSection?.nativeElement?.offsetHeight || 160;
  const MAX_HEIGHT = 650;
  const railOffset = Math.round(this.collabRailOffset());

  const available = MAX_HEIGHT - stickyH - upperH + railOffset;
  return `${Math.max(200, available)}px`;
});
onSwitchListScroll(event: Event): void {
  const el = event.target as HTMLElement;
  const prevScrollTop = this.switchListLastScrollTop;
  const scrollDelta = el.scrollTop - prevScrollTop;
  this.switchListLastScrollTop = el.scrollTop;

  if (scrollDelta > 0) {
    this.switchRailTarget = Math.min(
      this.switchRailMax,
      this.switchRailTarget + scrollDelta * 0.3
    );
    this.smoothSwitchRail();
  } else if (scrollDelta < 0 && this.switchRailOffset() > 0) {
    this.switchRailTarget = 0;
    this.smoothSwitchRail();
  }
}

setupSwitchListTouchTracking(): void {
  this.switchListTouchCleanup?.();
  this.switchListTouchCleanup = null;

  const listEl = this.switchListScroll?.nativeElement;
  if (!listEl) return;

  let lastTouchY = 0;

  const onTouchStart = (e: TouchEvent) => {
    lastTouchY = e.touches[0].clientY;
    this.switchRailTarget = Math.max(0, Math.min(listEl.scrollTop, this.switchRailMax));
  };

  const onTouchMove = (e: TouchEvent) => {
    const currentY = e.touches[0].clientY;
    const delta = lastTouchY - currentY;
    lastTouchY = currentY;

    if (delta > 0) {
      this.switchRailTarget = Math.min(this.switchRailMax, this.switchRailTarget + delta * 0.3);
      this.smoothSwitchRail();
    } else if (delta < 0 && this.switchRailOffset() > 0) {
      this.switchRailTarget = 0;
      this.smoothSwitchRail();
    }
  };

  listEl.addEventListener('touchstart', onTouchStart, { passive: true });
  listEl.addEventListener('touchmove', onTouchMove, { passive: true });

  this.switchListTouchCleanup = () => {
    listEl.removeEventListener('touchstart', onTouchStart);
    listEl.removeEventListener('touchmove', onTouchMove);
  };
}
setupCollabListTouchTracking(): void {
  this.collabListTouchCleanup?.();
  this.collabListTouchCleanup = null;

  const listEl = this.collabListScroll?.nativeElement;
  if (!listEl) return;

  let touchStartY = 0;
  let lastTouchY = 0;
  let lastRailOffset = 0;

  const onTouchStart = (e: TouchEvent) => {
    touchStartY = e.touches[0].clientY;
    lastTouchY = touchStartY;
    lastRailOffset = this.collabRailOffset();
    this.collabRailTarget = Math.max(0, Math.min(listEl.scrollTop, this.collabRailMax));
  };

  const onTouchMove = (e: TouchEvent) => {
    const currentY = e.touches[0].clientY;
    const delta = lastTouchY - currentY; 
    lastTouchY = currentY;

    if (delta > 0) {
      this.collabRailTarget = Math.min(
        this.collabRailMax,
        this.collabRailTarget + delta * 0.3
      );
      this.smoothCollabRail();
    } else if (delta < 0 && this.collabRailOffset() > 0) {
      this.collabRailTarget = 0;
      this.smoothCollabRail();
    }
  };

  listEl.addEventListener('touchstart', onTouchStart, { passive: true });
  listEl.addEventListener('touchmove', onTouchMove, { passive: true });

  this.collabListTouchCleanup = () => {
    listEl.removeEventListener('touchstart', onTouchStart);
    listEl.removeEventListener('touchmove', onTouchMove);
  };
}

setupCollabRail(): void {
  setTimeout(() => {
    const upper = this.collabUpperSection?.nativeElement;
    if (!upper) return;
 this.recalcCollabRailMax();
    this.collabUpperHeight = upper.offsetHeight;
    this.collabRailMax = upper.offsetHeight;

    const container = upper.closest('.relative.overflow-hidden') as HTMLElement;
    if (!container) return;

    // Wheel on upper section → move rail
    const onWheel = (e: WheelEvent) => {
      if (this.collabRailMax <= 0) return;
      const target = e.target as HTMLElement;
      const listEl = this.collabListScroll?.nativeElement;
      const isInsideList = listEl && listEl.contains(target);
      if (isInsideList) {
        // A short list never scrolls, so its scroll event can't reveal the buttons; do it here.
        if (e.deltaY < 0 && listEl.scrollTop <= 0 && this.collabRailOffset() > 0) {
          this.isUpperHidden = false;
          this.collabRailTarget = 0;
          this.smoothCollabRail();
        }
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      this.collabRailTarget += e.deltaY * 0.6;
      this.collabRailTarget = Math.max(0, Math.min(this.collabRailTarget, this.collabRailMax));
      this.smoothCollabRail();
    };

    let touchStartY = 0;
    const onTouchStart = (e: TouchEvent) => {
      const target = e.target as HTMLElement;
      const listEl = this.collabListScroll?.nativeElement;
      if (listEl && listEl.contains(target)) return;
      touchStartY = e.touches[0].clientY;
      this.collabRailTarget = this.collabRailOffset();
    };

    const onTouchMove = (e: TouchEvent) => {
      if (this.collabRailMax <= 0) return;
      const target = e.target as HTMLElement;
      const listEl = this.collabListScroll?.nativeElement;
      if (listEl && listEl.contains(target)) return;

      if (e.cancelable) e.preventDefault();
      const delta = touchStartY - e.touches[0].clientY;
      touchStartY = e.touches[0].clientY;

      this.collabRailTarget += delta * 0.6;
      this.collabRailTarget = Math.max(0, Math.min(this.collabRailTarget, this.collabRailMax));
      this.smoothCollabRail();
    };

    container.addEventListener('wheel', onWheel, { passive: false });
    container.addEventListener('touchstart', onTouchStart, { passive: true });
    container.addEventListener('touchmove', onTouchMove, { passive: false });

    this.collabRailCleanup = () => {
      container.removeEventListener('wheel', onWheel);
      container.removeEventListener('touchstart', onTouchStart);
      container.removeEventListener('touchmove', onTouchMove);
    };
  }, 300);
}
private recalcCollabRailMax(): void {
  const upper = this.collabUpperSection?.nativeElement;
  if (!upper) return;
  this.collabUpperHeight = upper.offsetHeight;
  this.collabRailMax = upper.offsetHeight + 8; 
}

private smoothCollabRail(): void {
  if (this.collabRailAnimId) {
    cancelAnimationFrame(this.collabRailAnimId);
    this.collabRailAnimId = null;
  }

  const animate = () => {
    const current = this.collabRailOffset();
    const diff = this.collabRailTarget - current;

    if (Math.abs(diff) < 1) {
      this.collabRailOffset.set(this.collabRailTarget);
      this.collabRailOffsetOut.emit(this.collabRailTarget);
      this.collabRailAnimId = null;
      this.cdr.detectChanges();
      return;
    }

    const next = current + diff * 0.18;
    this.collabRailOffset.set(next);
    this.collabRailOffsetOut.emit(Math.round(next));
    this.collabRailAnimId = requestAnimationFrame(animate);
  };

  this.collabRailAnimId = requestAnimationFrame(animate);
}

switchToCollabsTab(): void {
  this.switchRailCleanup?.();
  this.switchRailCleanup = null;
    this.isUpperHidden = false; 
  this.switchRailOffset.set(0);
  this.switchRailTarget = 0;
  this.collabRailOffsetOut.emit(0);
  this.listLastScrollTop = 0;
  this.mobileActiveTab.set('collabs');
  this.collabRailOffset.set(0);
  this.collabRailTarget = 0;
  this.collabUpperHeight = 0;
  if (!this.myCollabs().length) {
    this.fetchMyCollabs(true);
  }
  setTimeout(() => this.setupCollabRail(), 100);
}

switchToSwitchTab(): void {
  this.collabRailCleanup?.();
  this.collabRailCleanup = null;
  this.collabListTouchCleanup?.(); 
  this.collabRailOffset.set(0);
  this.collabRailTarget = 0;
  this.switchListLastScrollTop = 0; 
  this.collabRailOffsetOut.emit(0); 
  this.mobileActiveTab.set('switch');
  this.switchRailOffset.set(0);
  this.switchRailTarget = 0;
  this.switchUpperHeight = 0;
  setTimeout(() => this.setupSwitchRail(), 100);
}

readonly switchListMaxHeight = computed(() => {
  const stickyH = this.getStickyHeaderHeight();
  const panelMax = Math.min(640, window.innerHeight - 136);
  const upperH = this.switchUpperHeight || 90;
  return `${Math.max(200, panelMax - stickyH - upperH + Math.round(this.switchRailOffset()))}px`;
});

setupSwitchRail(): void {
  setTimeout(() => {
    const upper = this.switchUpperSection?.nativeElement;
    if (!upper) return;

    this.switchUpperHeight = upper.offsetHeight;
    const stickyH = this.getStickyHeaderHeight();
    const panelMax = Math.min(640, window.innerHeight - 136);
    this.switchRailMax = panelMax - stickyH;

    const container = upper.closest('.relative.overflow-hidden') as HTMLElement;
    if (!container) return;

    const onWheel = (e: WheelEvent) => {
      if (this.switchRailMax <= 0) return;
      const target = e.target as HTMLElement;
      const innerScroll = target.closest('.overflow-y-auto') as HTMLElement | null;
      if (innerScroll && container.contains(innerScroll)) {
        const { scrollTop, scrollHeight, clientHeight } = innerScroll;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
        const atTop = scrollTop === 0;
        if ((e.deltaY > 0 && !atBottom) || (e.deltaY < 0 && !atTop)) return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.switchRailTarget += e.deltaY * 0.5;
      this.switchRailTarget = Math.max(0, Math.min(this.switchRailTarget, this.switchRailMax));
      this.smoothSwitchRail();
    };

    let touchStartY = 0;
    const onTouchStart = (e: TouchEvent) => {
      touchStartY = e.touches[0].clientY;
      this.switchRailTarget = this.switchRailOffset();
    };

    const onTouchMove = (e: TouchEvent) => {
      if (this.switchRailMax <= 0) return;
      const target = e.target as HTMLElement;
      const innerScroll = target.closest('.overflow-y-auto') as HTMLElement | null;
      if (innerScroll && container.contains(innerScroll)) {
        const { scrollTop, scrollHeight, clientHeight } = innerScroll;
        const delta = touchStartY - e.touches[0].clientY;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
        const atTop = scrollTop === 0;
        if ((delta > 0 && !atBottom) || (delta < 0 && !atTop)) {
          touchStartY = e.touches[0].clientY;
          return;
        }
      }
      if (e.cancelable) e.preventDefault();
      const delta = touchStartY - e.touches[0].clientY;
      touchStartY = e.touches[0].clientY;
      this.switchRailTarget += delta * 0.5;
      this.switchRailTarget = Math.max(0, Math.min(this.switchRailTarget, this.switchRailMax));
      this.smoothSwitchRail();
    };

    container.addEventListener('wheel', onWheel, { passive: false });
    container.addEventListener('touchstart', onTouchStart, { passive: true });
    container.addEventListener('touchmove', onTouchMove, { passive: false });

    this.switchRailCleanup = () => {
      container.removeEventListener('wheel', onWheel);
      container.removeEventListener('touchstart', onTouchStart);
      container.removeEventListener('touchmove', onTouchMove);
    };
     this.setupSwitchListTouchTracking(); 
  }, 300);
}

private smoothSwitchRail(): void {
  const list = this.switchListScroll?.nativeElement;
  const contentH = (list?.lastElementChild as HTMLElement | null)?.offsetHeight ?? 0;
  if (list && this.switchUpperHeight && contentH <= Math.max(200, list.clientHeight - this.switchRailOffset())) {
    this.switchRailTarget = Math.min(this.switchRailTarget, this.switchUpperHeight);
  }
  if (this.switchRailAnimId) {
    cancelAnimationFrame(this.switchRailAnimId);
    this.switchRailAnimId = null;
  }

  const animate = () => {
    const current = this.switchRailOffset();
    const diff = this.switchRailTarget - current;

    if (Math.abs(diff) < 1) {
      this.switchRailOffset.set(this.switchRailTarget);
      this.collabRailOffsetOut.emit(this.switchRailTarget);
      this.switchRailAnimId = null;
      this.cdr.detectChanges();
      return;
    }

    const next = current + diff * 0.18;
    this.switchRailOffset.set(next);
    this.collabRailOffsetOut.emit(Math.round(next));
    this.switchRailAnimId = requestAnimationFrame(animate);
  };

  this.switchRailAnimId = requestAnimationFrame(animate);
}
ngAfterViewInit(): void {
  if (this.showTabs()) {
    this.setupCollabRail();
  }
}
 ngOnDestroy() {
  window.removeEventListener('resize', this.resizeHandler);
  window.removeEventListener('orientationchange', this.resizeHandler);
  this.collabRailCleanup?.();
  
  if (this.collabRailAnimId) cancelAnimationFrame(this.collabRailAnimId);
  this.switchRailCleanup?.();
  if (this.switchRailAnimId) cancelAnimationFrame(this.switchRailAnimId);
  this.destroy$.next();
  this.destroy$.complete();
}

   async navigateToAddAccount(): Promise<void> {
 try {
  const userId = this.currentUser?.user_id || this.auth.getUser()?.user_id || '';
    if (!userId) {
      console.warn('Cannot add account: no current user');
      return;
    }
    await this.router.navigate(
      ['/add-account/login'],
      { queryParams: { login_by: userId } }
    );
  } finally {
    this.closePanel.emit();
  }
}

  checkScreenSize() {
    this.isDesktop = window.innerWidth >= 1024;
  }

  async fetchSessionProfiles(mainUserTokenParam?: string): Promise<void> {
    try {
      if (this.isLoadingProfiles) {
        return;
      }

      this.isLoadingProfiles = true;
      const response = await this.userClient.getSessionProfiles(mainUserTokenParam);

      let sessionProfilesFromAPI: ISessionProfile[] = [];
      if (Array.isArray(response)) {
        sessionProfilesFromAPI = response;
      } else if (response && (response as any).status && (response as any).data) {
        sessionProfilesFromAPI = (response as any).data;
      } else {
        this.toastr.showError('Failed to load session profiles');
        return;
      }

      const storedSessionProfiles = localStorage.getItem('session_profiles');
      let refreshTokenMap = new Map<string, string>();
      let parsedSessionProfiles: Array<{ user_id: string; refreshToken: string; session_id?: string }> = [];

      if (storedSessionProfiles) {
        try {
          parsedSessionProfiles = JSON.parse(storedSessionProfiles);

          parsedSessionProfiles.forEach((profile: any) => {
            if (profile.user_id && profile.refreshToken) {
              if (!refreshTokenMap.has(profile.user_id)) {
                refreshTokenMap.set(profile.user_id, profile.refreshToken);
              }
            }
          });
        } catch (e) {
          console.error('Error parsing stored session profiles from login:', e);
        }
      }

      if (parsedSessionProfiles.length === 0) {
        
        const toSeed = sessionProfilesFromAPI
          .filter((p: any) => p.user_id && p.refreshToken)
          .map((p: any) => ({
            user_id: String(p.user_id),
            refreshToken: p.refreshToken,
            ...(p.session_id ? { session_id: p.session_id } : {})
          }));

        if (toSeed.length > 0) {
          localStorage.setItem('session_profiles', JSON.stringify(toSeed));
          toSeed.forEach((p: any) => refreshTokenMap.set(p.user_id, p.refreshToken));
        }
      }

      const storedMainRefreshToken = localStorage.getItem(mainUserRefreshToken);
      const storedMainSessionId = localStorage.getItem(mainUserSessionId);
      const storedMainUserId = localStorage.getItem(mainUserId); // Get main user ID from login
      const currentUserId = this.currentUser?.user_id;

      this.sessionProfiles = sessionProfilesFromAPI.map(profile => {
        const refreshTokenFromLogin = refreshTokenMap.get(String(profile.user_id));
        let refreshToken = refreshTokenFromLogin || profile.refreshToken;

        const isMainUserProfile = (storedMainUserId && String(profile.user_id) === String(storedMainUserId)) ||
          profile.is_default ||
          (String(profile.user_id) === String(currentUserId) && !storedMainUserId);

        if (isMainUserProfile && storedMainRefreshToken) {
          refreshToken = storedMainRefreshToken;
        }
        // If this is the main user profile and we have stored session_id, use it
        let sessionId = profile.session_id;
        if (isMainUserProfile && storedMainSessionId) {
          sessionId = storedMainSessionId;
        }

        return {
          ...profile,
          refreshToken: refreshToken || profile.refreshToken,
          session_id: sessionId || profile.session_id
        };
      });

      // Sort profiles: main account (is_default: true) always first
      // Use API data as-is, just ensure proper sorting
      this.sessionProfiles.sort((a, b) => {
        if (a.is_default && !b.is_default) return -1;
        if (!a.is_default && b.is_default) return 1;
        return 0;
      });

    } catch (error: any) {
      this.toastr.showError('Unable to load session profiles. Please try again.');
    } finally {
      this.isLoadingProfiles = false;
    }
  }

  async onSwitchProfile(profile: ISessionProfile): Promise<void> {
    // Already logged in as this account — do nothing
    if (profile.user_id === this.currentUser?.user_id) return;

    try {
      this.spinner.showSpinner();

      // Get main user token BEFORE making switch_profile API call
      const mainToken = localStorage.getItem(mainUserToken);
      if (!mainToken) {
        console.error('Main user token not found - cannot switch profile properly!');
        this.toastr.showError('Main user token not found. Please login again.');
        this.spinner.hideSpinner();
        return;
      }

      const storedMainUserId = localStorage.getItem(mainUserId);
      const currentUserId = this.currentUser?.user_id; // Current logged-in user ID before switch
      const isMainUser = (storedMainUserId && profile.user_id === storedMainUserId) ||
        profile.is_default ||
        (!storedMainUserId && profile.user_id === currentUserId);

      let refreshTokenToUse: string | undefined = profile.refreshToken;

      if (isMainUser) {
        const storedMainRefreshToken = localStorage.getItem(mainUserRefreshToken);
        if (storedMainRefreshToken) {
          console.log('Switching to main account, using stored main user refresh token');
          refreshTokenToUse = storedMainRefreshToken;
        } else {
          console.error('Main user refresh token not found in localStorage - this should be set during login!');
          if (!refreshTokenToUse) {
            console.warn('Profile refreshToken also not available');
            const currentProfile = this.sessionProfiles.find(p =>
              (storedMainUserId && p.user_id === storedMainUserId) || p.is_default
            );
            refreshTokenToUse = currentProfile?.refreshToken || undefined;
          }
        }
      }

      // Final check - if still no refresh token, show error
      if (!refreshTokenToUse) {
        if (isMainUser) {
          console.error('Main user refresh token not available. This should be set during login.');
          this.toastr.showError('Main account refresh token not found. Please login again.');
        } else {
          this.toastr.showError('Refresh token not available for this profile. Please login again.');
        }
        this.spinner.hideSpinner();
        return;
      }

      if (!isMainUser && storedMainUserId) {
        const mainUserProfile = this.sessionProfiles.find(p =>
          (storedMainUserId && p.user_id === storedMainUserId) || p.is_default
        );

        if (mainUserProfile?.refreshToken) {
          console.log('Storing main user refresh token before switching away:', {
            user_id: storedMainUserId,
            refreshToken: mainUserProfile.refreshToken.substring(0, 20) + '...'
          });
          localStorage.setItem(mainUserRefreshToken, mainUserProfile.refreshToken);
          if (mainUserProfile.session_id) {
            localStorage.setItem(mainUserSessionId, mainUserProfile.session_id);
          }
        } else {
          const existingMainRefreshToken = localStorage.getItem(mainUserRefreshToken);
          if (!existingMainRefreshToken) {
            console.warn('Main user refresh token not found before switch');
          }
        }
      }

      const fcmToken = this.currentUser?.fcm_token || null;

      const deviceType = this.getDeviceType();

      let sessionIdToUse = profile.session_id;
      if (isMainUser) {
        const storedMainSessionId = localStorage.getItem(mainUserSessionId);
        if (storedMainSessionId) {
          sessionIdToUse = storedMainSessionId;
        }
      }

      const payload: ISwitchProfileRequest = {
        refresh_token: refreshTokenToUse,
        session_id: sessionIdToUse,
        ...(fcmToken && { fcm_token: fcmToken }),
        ...(deviceType && { device: deviceType }),
      };

      const response = await this.userClient.switchProfile(payload, mainToken);
      if (response.status && response.data) {
        const storedMainToken = localStorage.getItem(mainUserToken);
        if (!storedMainToken) {
          console.error('Main user token not found in localStorage after switch - this should not happen!');
        } else {
          console.log('Main user token preserved:', storedMainToken.substring(0, 20) + '...');
        }

        if (response.token) {
          localStorage.setItem(authToken, response.token);
        }

        if (!storedMainToken && response.token) {
          console.warn('Main user token missing, setting it from response (should not happen)');
          localStorage.setItem(mainUserToken, response.token);
        }

        if (response.refreshToken) {
          localStorage.setItem(authRefreshToken, response.refreshToken);
        } else if (refreshTokenToUse) {
          // Backend didn't rotate the refresh token on switch — keep using the one we sent.
          localStorage.setItem(authRefreshToken, refreshTokenToUse);
        }

        if (response.session_profiles && Array.isArray(response.session_profiles)) {
          localStorage.setItem('session_profiles', JSON.stringify(response.session_profiles));

          if (storedMainUserId) {
            const mainUserProfile = response.session_profiles.find((sp: any) => sp.user_id === storedMainUserId);
            if (mainUserProfile && mainUserProfile.refreshToken) {
              console.log('Found main user refreshToken in response.session_profiles, storing it:', {
                user_id: storedMainUserId,
                refreshToken: mainUserProfile.refreshToken.substring(0, 20) + '...'
              });
              localStorage.setItem(mainUserRefreshToken, mainUserProfile.refreshToken);
            }
          }
        }

        if (response.refreshToken && storedMainUserId && response.data.user_id === storedMainUserId) {
          localStorage.setItem(mainUserRefreshToken, response.refreshToken);
        }

        if (response.data.session_id && storedMainUserId && response.data.user_id === storedMainUserId) {
          console.log('Storing main user session_id from response');
          localStorage.setItem(mainUserSessionId, response.data.session_id);
        }

        // AuthService.updateData() does a full (non-merged) replace when user_id changes,
        // so the moderation status must be carried over explicitly here — otherwise it's
        // simply missing until the reload below re-fetches the profile from the server.
        response.data.profile_picture = profile.user_details.profile_picture;
        response.data.profile_picture_moderation_status = profile.user_details.profile_picture_moderation_status ?? null;
        this.auth.updateData(response.data);
        this.currentUser = response.data;

        if (storedMainToken) {
          try {
            console.log('onSwitchProfile: Fetching session profiles with MAIN USER token after switch');
            await this.fetchSessionProfiles(storedMainToken);
            this.cdr.detectChanges();
          } catch (error) {
            console.error('Error fetching session profiles after switch:', error);
          }
        } else {
          console.error('Cannot fetch session profiles: Main user token is missing!');
        }

        this.cdr.detectChanges();
        this.toastr.showSuccess('Profile switched successfully');
        this.spinner.hideSpinner();
        // Increase timeout to ensure API call completes before reload
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        const errorMessage = response.message || 'Failed to switch profile';
        this.toastr.showError(errorMessage);
        this.spinner.hideSpinner();
      }
    } catch (error: any) {

      let errorMessage = 'Unable to switch profile. Please try again.';
      if (error.error?.message) {
        errorMessage = error.error.message;
      } else if (error.message) {
        errorMessage = error.message;
      }

      if (errorMessage.toLowerCase().includes('no resource') ||
        errorMessage.toLowerCase().includes('not found') ||
        errorMessage.toLowerCase().includes('identifier')) {
        errorMessage = 'Profile not found. The refresh token may have expired. Please login again.';
      }

      this.toastr.showError(errorMessage);
      this.spinner.hideSpinner();
    }
  }

  getUserTypeLabel(userType: string): string {
    switch (userType) {
      case '2': return 'RESIDENT';
      case '3': return 'MANAGEMENT';
      case '4': return 'SERVICE PROVIDER';
      case '5': return 'CONTRACTOR';
      default: return userType.toUpperCase();
    }
  }

  getProfileName(profile: ISessionProfile): string {
    const userDetails = profile.user_details;
    if (userDetails.user_type === '3') {
      return userDetails.management_name ?? '';
    }
    if (userDetails.user_type === '4') {
      return userDetails.service_provider_name ?? '';
    }
    return `${userDetails.first_name} ${userDetails.last_name}`;
  }

  getProfileStatus(profile: ISessionProfile): string {
    return profile.is_active ? '1' : '0';
  }

  onProfileClick(event: Event) {
    if (this.currentUser?.user_id) {
      this.router.navigate(['/contacts', this.currentUser.user_id]);
    }
  }

  toggleProfileMenu(event: Event) {
    if (this.showTabs()) {
      this.showDotsMenu.update(v => !v);
    } else {
      this.profileMenu.toggle(event);
    }
  }

  readonly getVerifiedRequest = output<any>();

  onGetVerified(): void {
    const target = this.activeProfileForMenu;
    if (!target || String(target.user_id) === String(this.currentUser?.user_id)) {
      // No target, or the clicked row IS the currently active session — let the popup
      // read the live current user directly rather than a (possibly stale) snapshot.
      this.getVerifiedRequest.emit(null);
      return;
    }
    // While impersonating, the "Switch Account" row for the admin's own account may not
    // carry a full user_details sub-object (it isn't a regular added account), which
    // would silently fall back to the impersonated user's data. Use the admin snapshot
    // captured at impersonation start instead whenever this row is that account.
    if (this.impersonationService.isImpersonating()) {
      const adminSnapshot = this.impersonationService.getStoredAdminUser();
      if (adminSnapshot && String(adminSnapshot.user_id) === String(target.user_id)) {
        this.getVerifiedRequest.emit(adminSnapshot);
        return;
      }
    }
    this.getVerifiedRequest.emit(target.user_details);
  }

  isVerificationSnoozed(): boolean {
     return GetVerifiedPopupComponent.isVerificationSnoozed();
  }

  updateMenuItems() {
    this.menuItems = [];
    if (!this.currentUser?.is_verified) {
      this.menuItems.push({
        label: 'Get verified',
        icon: 'pi pi-verified',
        command: () => this.onGetVerified()
      });
    }

    this.menuItems.push({
      label: 'View Profile Center',
      icon: 'pi pi-user',
      command: () => this.onViewProfile()
    });

    this.menuItems.push({
      label: 'Logout',
      icon: 'pi pi-sign-out',
      command: () => this.onLogout()
    });
  }

  onViewProfile() {
    if (this.currentUser?.user_id) {
      this.router.navigate(['/contacts', this.currentUser.user_id]);
    }
    this.closePanel.emit();
  }

  toggleAccountMenu(event: Event, profile: ISessionProfile, index?: number) {
    event.stopPropagation();
    this.activeProfileForMenu = profile;
    if (this.showTabs() && index !== undefined) {
      this.showAccountMenuIndex.update(v => v === index ? null : index);
    } else {
      this.accountMenu.toggle(event);
    }
  }

  onViewProfileCenter() {
    if (this.activeProfileForMenu) {
      this.router.navigate(['/contacts', this.activeProfileForMenu.user_id]);
    }
  }

  onRemoveAccount() {
    if (!this.activeProfileForMenu) return;
    if (this.activeProfileForMenu.user_id === this.currentUser?.user_id) {
      this.toastr.showError('Cannot remove currently active profile. Please switch accounts first.');
      return;
    }
    const removedProfile = this.activeProfileForMenu;
    this.activeProfileForMenu = null;

    const payload: Record<string, any> = {
      session_id: removedProfile.session_id,
    };
    const fcmToken = this.currentUser?.fcm_token;
    if (fcmToken) payload['fcmTokenId'] = fcmToken;

    this.httpClient.post('logout', payload).subscribe({
      next: () => {
        this.removeProfileLocally(removedProfile);
        this.toastr.showSuccess(`Account ${this.getProfileName(removedProfile)} removed from list`);
      },
      error: () => {
        this.removeProfileLocally(removedProfile);
        this.toastr.showSuccess(`Account ${this.getProfileName(removedProfile)} removed from list`);
      }
    });
  }

  private removeProfileLocally(removedProfile: ISessionProfile): void {
    this.sessionProfiles = this.sessionProfiles.filter(p => p.user_id !== removedProfile.user_id);
    const storedProfilesData = localStorage.getItem('session_profiles');
    if (storedProfilesData) {
      try {
        let profiles = JSON.parse(storedProfilesData);
        if (Array.isArray(profiles)) {
          profiles = profiles.filter((p: any) => p.user_id !== removedProfile.user_id);
          localStorage.setItem('session_profiles', JSON.stringify(profiles));
        }
      } catch (e) {
        console.error('Error updating session_profiles in localStorage:', e);
      }
    }
  }

  onLogout() {
    this.auth.logout();
  }

  onCarouselWheel(event: WheelEvent) {
    event.stopPropagation();
  }

  fetchMyCollabs(reset = true): void {
  if (reset) {
    if (this.isLoadingMyCollabs()) return;
    this.isLoadingMyCollabs.set(true);
    this.collabPage.set(1);
  } else {
    if (this.isLoadingMoreCollabs()) return;
    this.isLoadingMoreCollabs.set(true);
  }
  const page = reset ? 1 : this.collabPage();
  this.httpClient.getWithParams('collab/list', {
    filter: 'my_collabs',
    recently_viewed_order: 'true',
    page,
    limit: this.COLLAB_PAGE_LIMIT,
  }).subscribe({
    next: (res: any) => {
      const data = Array.isArray(res?.data) ? res.data : [];
      const mapped = data.map((c: any) => ({
        collab_id: c.collab_id || c.id,
        title: c.title || 'Untitled Collab',
        display_image: CollabService.getDisplayImage(c),
        relative_time: this.getRelativeTime(c.last_viewed_date),
      }));

      if (reset) {
        this.myCollabs.set(mapped);
        this.isLoadingMyCollabs.set(false);
      } else {
        this.myCollabs.update(prev => [...prev, ...mapped]);
        this.isLoadingMoreCollabs.set(false);
      }

      this.collabHasMore.set(data.length >= this.COLLAB_PAGE_LIMIT);
      this.cdr.detectChanges();
      
      setTimeout(() => {
  this.collabUpperHeight = this.collabUpperSection?.nativeElement?.offsetHeight || 0;
  this.collabRailMax = this.collabUpperHeight;
  this.recalcCollabRailMax();
  this.setupListTouchHideReveal(); 
  this.cdr.detectChanges();
}, 100);
    },
    error: () => {
      this.isLoadingMyCollabs.set(false);
      this.isLoadingMoreCollabs.set(false);
    }
  });
}
private setupListTouchHideReveal(): void {
  const listEl = this.collabListScroll?.nativeElement;
  if (!listEl) return;

  let touchStartY = 0;

  const onTouchStart = (e: TouchEvent) => {
    touchStartY = e.touches[0].clientY;
  };

  const onTouchMove = (e: TouchEvent) => {
    const delta = touchStartY - e.touches[0].clientY;
    const THRESHOLD = 15;

    if (delta > THRESHOLD && !this.isUpperHidden) {
      this.isUpperHidden = true;
      this.collabRailTarget = this.collabRailMax;
      this.smoothCollabRail();
    } else if (delta < -THRESHOLD && (this.isUpperHidden || this.collabRailOffset() > 0)) {
      this.isUpperHidden = false;
      this.collabRailTarget = 0;
      this.smoothCollabRail();
    }
  };

  listEl.addEventListener('touchstart', onTouchStart, { passive: true });
  listEl.addEventListener('touchmove', onTouchMove, { passive: true });

  // Store cleanup
  this.collabListTouchCleanup = () => {
    listEl.removeEventListener('touchstart', onTouchStart);
    listEl.removeEventListener('touchmove', onTouchMove);
  };
}
onCollabListScroll(event: Event): void {
  const el = event.target as HTMLElement;
  const currentScrollTop = el.scrollTop;
  const delta = currentScrollTop - this.lastListScrollTop;
  this.lastListScrollTop = currentScrollTop;

  const HIDE_THRESHOLD = 10;   
  const SHOW_THRESHOLD = 5;    

  if (delta > HIDE_THRESHOLD && !this.isUpperHidden) {
    this.isUpperHidden = true;
    this.collabRailTarget = this.collabRailMax;
    this.smoothCollabRail();
  } else if (delta < -SHOW_THRESHOLD && this.isUpperHidden) {
    this.isUpperHidden = false;
    this.collabRailTarget = 0;
    this.smoothCollabRail();
  }

  // Pagination
  const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 50;
  if (nearBottom && !this.isLoadingMoreCollabs() && this.collabHasMore()) {
    this.collabPage.update(p => p + 1);
    this.fetchMyCollabs(false);
  }
}
  goToCollab(collabId: string): void {
    this.router.navigate(['/collab', collabId]);
  }

  onExploreCollabs(): void {
    this.router.navigate(['/collab']);
    this.closePanel.emit();
  }

  onStartCollab(): void {
     if (this.collabListComponent) {
            this.collabListComponent.isCollabAddPopupVisible = true;
        }
  }

  onMobileCollabClick(collabId: string): void {
    this.goToCollab(collabId);
    this.closePanel.emit();
  }
  

  onImgError(event: Event): void {
    const img = event.target as HTMLImageElement | null;
    if (!img || img.src.endsWith(this.fallbackImage)) return;
    img.src = this.fallbackImage;
  }

  private getRelativeTime(dateString: string | null): string {
    if (!dateString) return '';
    try {
      const timestamp = Date.parse(dateString);
      if (!Number.isFinite(timestamp)) return '';
      const diffMs = Date.now() - timestamp;
      if (diffMs < 0) return 'Just now';
      const mins = Math.floor(diffMs / 60000);
      const hours = Math.floor(diffMs / 3600000);
      const days = Math.floor(diffMs / 86400000);
      const weeks = Math.floor(days / 7);
      const months = Math.floor(days / 30);
      if (mins < 1) return 'Just now';
      if (mins < 60) return `${mins} min${mins !== 1 ? 's' : ''} ago`;
      if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
      if (days < 7) return `${days} day${days !== 1 ? 's' : ''} ago`;
      if (weeks < 4) return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
      return `${months} month${months !== 1 ? 's' : ''} ago`;
    } catch {
      return '';
    }
  }

  checkRoute(): void {
    const url = this.router.url.split('?')[0].split('#')[0];
    this.isContactRoute = url === '/contacts' || url.startsWith('/contacts/');
    this.isFundraiseRoute = url === '/fundraise' || url.startsWith('/fundraise');
    this.isPrimeRoute = /^\/prime(\/|$)/.test(url);
    const isHomeRoute = url === '/home' || url === '/';
   if (isHomeRoute) {
     this.isMyCollab = true;
    this.fetchMyCollabs();
  }
    if (this.isContactRoute) {
      this.fetchProfileData();
      this.fetchContactMetrics();
    }
    else {
      this.location = '';
      this.contactsCount = '';
      this.followersCount = '';
      this.profileData = null;
      this.resetContactMetrics();
    }
  }
  getUserName(): string {
    const u = this.currentUser;
    if (!u) return '—';
    if (u.user_type === '3') {
      return u.management_name || '—';
    }
    return `${u.first_name ?? ''} ${u.last_name ?? ''}`.trim() || u.service_provider_name || '—';
  }

  fetchProfileData(): void {
    if (this.isLoadingProfile()) return;

    this.isLoadingProfile.set(true);
    this.httpClient.get('profile').subscribe({
      next: (response: any) => {
        this.isLoadingProfile.set(false);
        if (response && response.success && response.data) {
          this.profileData = response.data;
          this.setProfileFields(response.data);
        } else if (response && response.data) {
          this.profileData = response.data;
          this.setProfileFields(response.data);
        }
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.isLoadingProfile.set(false);
        this.cdr.detectChanges();
      }
    });
  }

  setProfileFields(data: any): void {
    if (data.addresses && data.addresses.length > 0) {
      const address = data.addresses[0];
      const city = address.city || '';
      const zipcode = address.zipcode || '';
      if (city && zipcode) {
        this.location = `${city} ${zipcode}`.trim();
      } else if (city) {
        this.location = city;
      } else if (zipcode) {
        this.location = zipcode;
      }
    } else if (data.city && data.zipcode) {
      this.location = `${data.city} ${data.zipcode}`.trim();
    } else if (data.city) {
      this.location = data.city;
    } else if (data.zipcode) {
      this.location = data.zipcode;
    }
     this.userName = [data.first_name, data.last_name]
      .filter(Boolean)
      .join(' ')
      .trim();

    if (data.contacts_count !== undefined && data.contacts_count !== null) {
      const count = typeof data.contacts_count === 'string' ? parseInt(data.contacts_count) : data.contacts_count;
      this.contactsCount = this.formatContactCount(count);
    } else if (data.total_contacts !== undefined && data.total_contacts !== null) {
      const count = typeof data.total_contacts === 'string' ? parseInt(data.total_contacts) : data.total_contacts;
      this.contactsCount = this.formatContactCount(count);
    }

    if (data.followers_count !== undefined && data.followers_count !== null) {
      const count = typeof data.followers_count === 'string' ? parseInt(data.followers_count) : data.followers_count;
      this.followersCount = this.formatContactCount(count);
    } else if (data.total_followers !== undefined && data.total_followers !== null) {
      const count = typeof data.total_followers === 'string' ? parseInt(data.total_followers) : data.total_followers;
      this.followersCount = this.formatContactCount(count);
    }
  }


  /**
   * Fetch contact metrics for Contacts page stats card
   * Endpoint: GET /api/contact_list/metrics
   */
  fetchContactMetrics(): void {
    if (this.isLoadingContactMetrics()) {
      return;
    }

    this.isLoadingContactMetrics.set(true);

    this.contactService.getContactMetrics({}).subscribe({
      next: (response: any) => {
        this.isLoadingContactMetrics.set(false);

        const data = response?.data || response;

        if (!data) {
          this.resetContactMetrics();
          return;
        }

        const format = (value: any): string => {
          const num = typeof value === 'string' ? parseInt(value, 10) : value;
          if (num === undefined || num === null || isNaN(num)) {
            return '0';
          }
          return this.formatContactCount(num);
        };

        this.totalContactsMetric.set(format(data.totalContacts));
        this.personalContactsMetric.set(format(data.personalContacts));
        this.businessContactsMetric.set(format(data.businessContacts));
        this.contractorsContactsMetric.set(format(data.contractorsContacts));
        this.managementContactsMetric.set(format(data.managementContacts));
        this.serviceProviderContactsMetric.set(format(data.serviceProviderContacts));
      },
      error: () => {
        this.isLoadingContactMetrics.set(false);
        this.resetContactMetrics();
      }
    });
  }

  private resetContactMetrics(): void {
    this.totalContactsMetric.set('');
    this.personalContactsMetric.set('');
    this.businessContactsMetric.set('');
    this.contractorsContactsMetric.set('');
    this.managementContactsMetric.set('');
    this.serviceProviderContactsMetric.set('');

  }

  fetchActivityPoints(): void {
    this.activityPointsService.getProfile().subscribe({
      next: (d) => {
        const total = Number(d.creation ?? 0) + Number(d.engagement ?? 0) + Number(d.connection ?? 0);
        this.lifetimeActivityPoints.set(this.formatActivityPoints(total));
        this.activityPointsLevel.set(d.activity_points_level ?? '');
        this.referralToken.set(d.referrer_token ?? '');
        this.cdr.detectChanges();
      },
      error: () => {}
    });
  }

  openInvitePopup(): void {
    this.showInvitePopup.set(true);
  }

  formatActivityPoints(n: number): string {
    if (n >= 1000000) return `${(n / 1000000).toFixed(1)}m pts`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}k pts`;
    return `${n} pts`;
  }

  formatContactCount(n: number): string {
    if (n >= 1000000) return `${(n / 1000000).toFixed(1)}m`;
    if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
    return `${n}`;
  }



  /**
   * Detect device type based on user agent
   * Returns 'ios', 'android', or 'web'
   */
  private getDeviceType(): string {
    if (typeof window === 'undefined' || !window.navigator) {
      return 'web';
    }

    const userAgent = window.navigator.userAgent.toLowerCase();

    // Check for iOS
    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'ios';
    }

    // Check for Android
    if (/android/.test(userAgent)) {
      return 'android';
    }

    // Default to web
    return 'web';
  }
}

